import { SET_VALUES_EVALUATOR, CLEAR_VALUES_EVALUATOR } from '@constants/actionType'

const initialState = {
  contacto: [],
  estatus: null,
  id: null,
  nombre: null,
  tipo: null,
  url: "",
  loadingEvaluator: false
};

function emailState(state = initialState, actions) {
  switch (actions.type) {
    case SET_VALUES_EVALUATOR:
      return { ...state, ...actions.payload };
    case CLEAR_VALUES_EVALUATOR:
      return {
        contacto: [],
        estatus: null,
        id: null,
        nombre: null,
        tipo: null,
        url: "",
        loadingEvaluator: false
      };
    default:
      return state;
  }
}

export default emailState;
